import * as React from "react";
import { useRef, useState } from "react";
import { Scroll } from "../../../../../../react-core/Utils/Scroll";
import { AccountSearchAction, IAdvancedSearchQuery } from "../../ClientRecord/Action/AccountSearchAction";
import { AccountSearchResultTable } from "./AccountSearchResultTable";
import { AdvancedSearch } from "./AdvanceSearch";
import { BasicSearch } from "./BasicSearch";

export const AccountSearchPanel = () => {
    const [data, setData] = useState(null);
    const [type, setType] = useState("basic");
    const [isSearching, setIsSearching] = useState(false);
    const [basicQuery, setBasicQuery] = useState({});
    const [advancedQuery, setAdvancedQuery] = useState([]);
    const searchResults = useRef();

    React.useEffect(() => {
        if (data !== null && !isSearching) {
            Scroll.scrollToElement(searchResults.current);
        }
    }, [data, isSearching]);

    const search = (query, currentPage, pageSize) => {
        setIsSearching(true);
        AccountSearchAction.searchAccounts(query, advancedQuery, currentPage, pageSize, (res) => {
            setIsSearching(false);
            setData(res);
        });
    };

    const onSearch = (query) => {
        setType("basic");
        setBasicQuery(query);
        search(query, 1, 10);
    };

    const onPageChange = (currentPage, pageSize) => {
        if (type == "basic") {
            search(basicQuery, currentPage, pageSize);
        }
    };

    const applyFilter = (query: IAdvancedSearchQuery[]) => {
        setAdvancedQuery(query);
        setData(null);
    };

    return (
        <>
            <BasicSearch
                onSearch={(query) => onSearch(query)}
                isSearching={isSearching}
                fromToolAndLiterature={false}
            />
            <hr className="mt-18" />
            <AdvancedSearch applyAdancedFilter={(query) => applyFilter(query)} />

            {data !== null && (
                <div className="row row-space-between mb-8">
                    <div className="col-auto">
                        <h2>Results</h2>
                    </div>
                </div>
            )}
            <AccountSearchResultTable
                data={data}
                onPageChange={(s, c) => onPageChange(s, c)}
                advancedQuery={advancedQuery}
                fromToolAndLiterature={false}
                basicQuery={basicQuery}
            />
        </>
    );
};
